import type { PropsWithChildren } from 'react';
import { forwardRef } from 'react';

import { Stack } from '../../components/stack';
import { useDocumentTitle } from '../../hooks/use-document-title';
import type { Theme } from '../../styles';

export type PageRootProps = PropsWithChildren<{
  title: string;
}>;

/** @experimental In active development. Avoid using until further notice. */
export const PageRootContent = forwardRef<HTMLElement, PropsWithChildren>(
  ({ children }, ref) => {
    return (
      <Stack
        ref={ref}
        className="page-root"
        direction="column"
        component="main"
        sx={(theme: Theme) => ({
          backgroundColor: theme.palette.background.base,
          height: '100%',
          overflow: 'auto',
          width: '100%',
        })}
      >
        {children}
      </Stack>
    );
  },
);

/** @experimental In active development. Avoid using until further notice. */
export const PageRoot = forwardRef<HTMLElement, PageRootProps>(
  ({ children, title }, ref) => {
    useDocumentTitle(title);

    return <PageRootContent ref={ref}>{children}</PageRootContent>;
  },
);
